import { buildBaseOverrides } from 'Components/UI/guidedHouseholdReview/baseOverrides';

export const metaOverrideSet = buildBaseOverrides();
